import { getApplicationProcessPath, getMeetingPath } from "@lib/routing";
import { useMemo } from "react";
import useLanguage from "./useLanguage";
import usePartnerContext from "./usePartnerContext";

const useLinks = () => {
  const { partner } = usePartnerContext();
  const locale = useLanguage();

  return useMemo(
    () => ({
      getMeetingLink: () => getMeetingPath(locale),
      getApplicationProcessLink(
        subPath?: string,
        query?: Record<string, string>,
      ) {
        return getApplicationProcessPath(locale, subPath, query, partner?.id);
      },
      getOffersLink: (processLink: string, applicationId?: string) => {
        let path: string;
        let params: URLSearchParams;
        if (processLink.includes("?")) {
          path = processLink.substring(0, processLink.indexOf("?"));
          params = new URLSearchParams(
            processLink.substring(processLink.indexOf("?")),
          );
        } else {
          path = processLink;
          params = new URLSearchParams();
        }
        if (applicationId) {
          params.append("applicationId", applicationId);
        }
        if (params.toString().length > 0) {
          return `https://justhome.com${path}?${params.toString()}`;
        } else {
          return `https://justhome.com${path}`;
        }
      },
    }),
    [partner?.id, locale],
  );
};

export default useLinks;
